import { render } from "./MenuItems.component.vue?vue&type=template&id=6fabdc58&scoped=true&ts=true"
import script from "./MenuItems.component.vue?vue&type=script&lang=ts"
export * from "./MenuItems.component.vue?vue&type=script&lang=ts"

import "./MenuItems.component.vue?vue&type=style&index=0&id=6fabdc58&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fabdc58"]])

export default __exports__